import { FC } from 'react';
import { Container } from './Tag.styles';
import { OfferSituation, StatusOffer, TagStatusLabel, TagActiveLabel, TagPaymentLabel } from '../../utils';
import { TagDeferralLabel } from '../../utils/enums/TagDeferralLabel';
import { TagBidLabel } from '../../utils/enums/TagStatusCotacao';

export interface TagProps {
	status: StatusOffer | OfferSituation | TagStatusLabel | TagActiveLabel | TagPaymentLabel | TagDeferralLabel | TagBidLabel;
}

const Tag: FC<TagProps> = ({ status }) => {
	return <Container $status={status}>{status}</Container>;
};

export default Tag;
